var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShowMoreLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-loaction-svgrepo-com 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9231 6.9529C1.92338 4.58996 3.59276 2.55628 5.91033 2.09555C8.22791 1.63483 10.5482 2.87537 11.4522 5.05852C12.3562 7.24166 11.5922 9.75942 9.62745 11.072C7.66261 12.3846 5.04419 12.1264 3.37349 10.4555C2.44467 9.52647 1.92294 8.26651 1.9231 6.9529Z",
    stroke: "#535353",
    strokeWidth: 1.23824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5676 10.2549L13.4799 12.7314",
    stroke: "#535353",
    strokeWidth: 1.23824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.7787 4.20508C5.61963 4.20508 4.67999 5.14444 4.67999 6.3035C4.67999 7.2403 6.05165 8.94819 6.57718 9.56808C6.60183 9.59757 6.63265 9.6213 6.66747 9.63758C6.70229 9.65385 6.74026 9.66229 6.7787 9.66229C6.81713 9.66229 6.8551 9.65385 6.88992 9.63758C6.92474 9.6213 6.95556 9.59757 6.98021 9.56808C7.50574 8.94819 8.8774 7.24058 8.8774 6.3035C8.8774 5.14444 7.93776 4.20508 6.7787 4.20508ZM6.7787 6.93362C6.40182 6.93362 6.09656 6.62808 6.09656 6.25148C6.09656 5.8746 6.4021 5.56935 6.7787 5.56935C7.15529 5.56935 7.46083 5.8746 7.46083 6.25148C7.46083 6.62808 7.15529 6.93362 6.7787 6.93362Z",
    fill: "#535353"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMoreLocation);
export default __webpack_public_path__ + "static/media/show-more-location.b4ad1ea7ecf23ae49fd217be34e8376f.svg";
export { ForwardRef as ReactComponent };